import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './News.css';
import { fetchDigestList } from './newsApi';
import { formatDayLabel, formatShortDate, kstDay } from './newsFormat';
import NewsSubscribe from './components/NewsSubscribe';

const DESCRIPTION = '매일 아침 8시, 선생님께 필요한 교육 정책·학교 현장·에듀테크 소식을 3분 안에 읽을 수 있게 정리해요.';

const NewsListPage = () => {
  const [state, setState] = useState({ status: 'loading', digests: [] });

  useEffect(() => {
    let cancelled = false;
    fetchDigestList()
      .then((digests) => !cancelled && setState({ status: 'ready', digests }))
      .catch(() => !cancelled && setState({ status: 'error', digests: [] }));
    return () => { cancelled = true; };
  }, []);

  const [latest, ...past] = state.digests;
  // 08시 발행 전에는 어제 호가 맨 위에 있다.
  const latestLabel = !latest ? '' : latest.date === kstDay(0) ? '오늘' : latest.date === kstDay(1) ? '어제' : '최신';

  return (
    <div className="news-page">
      <Helmet>
        <title>아침 교육 뉴스 | 왓퀴즈</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href="https://whatquiz.co.kr/news" />
      </Helmet>

      <header className="news-hero">
        <p className="news-eyebrow">매일 아침 8시</p>
        <h1 className="news-headline">아침 교육 뉴스</h1>
        <p className="news-lead">{DESCRIPTION}</p>
      </header>

      {state.status === 'loading' && (
        <div aria-busy="true" aria-label="뉴스를 불러오는 중">
          <div className="news-skeleton news-skeleton--card" />
          <div className="news-skeleton news-skeleton--row" />
          <div className="news-skeleton news-skeleton--row" />
        </div>
      )}

      {state.status === 'error' && (
        <div className="news-empty">
          <p>뉴스를 불러오지 못했어요. 잠시 후 다시 들어와 주세요.</p>
        </div>
      )}

      {state.status === 'ready' && !latest && (
        <div className="news-empty">
          <p>첫 뉴스가 곧 올라와요. 내일 아침 8시에 만나요.</p>
        </div>
      )}

      {latest && (
        <Link to={`/news/${latest.date}`} className={`news-latest ${latest.thumbnail ? 'news-latest--thumb' : ''}`}>
          {latest.thumbnail && <img className="news-latest-thumb" data-testid="news-thumb" src={latest.thumbnail} alt="" />}
          <span className="news-chip news-chip--strong">{latestLabel}</span>
          <p className="news-eyebrow">{formatDayLabel(latest.date)}</p>
          <strong className="news-latest-title">{latest.headline}</strong>
          <ul className="news-latest-lines">
            {latest.three_lines.map((line) => <li key={line}>{line}</li>)}
          </ul>
          <span className="news-btn-primary news-latest-cta">{latestLabel} 뉴스 읽기</span>
        </Link>
      )}

      {past.length > 0 && (
        <section className="news-section" aria-labelledby="news-archive-title">
          <h2 id="news-archive-title" className="news-section-title">지난 뉴스</h2>
          <ul className="news-archive">
            {past.map((digest) => (
              <li key={digest.date}>
                <Link to={`/news/${digest.date}`} className="news-archive-row">
                  {digest.thumbnail && (
                    <img className="news-archive-thumb" data-testid="news-thumb" src={digest.thumbnail} alt="" loading="lazy" />
                  )}
                  <span className="news-archive-date">{formatShortDate(digest.date)}</span>
                  <span className="news-archive-title">{digest.headline}</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      )}

      <NewsSubscribe />
    </div>
  );
};

export default NewsListPage;
